export default __webpack_public_path__ + "static/media/Q3-1.fa1a37fe.jpg";